import { render, staticRenderFns } from "./SignageHeader.vue?vue&type=template&id=2c1f7692&scoped=true&"
import script from "./SignageHeader.vue?vue&type=script&lang=js&"
export * from "./SignageHeader.vue?vue&type=script&lang=js&"
import style0 from "./SignageHeader.vue?vue&type=style&index=0&id=2c1f7692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f7692",
  null
  
)

export default component.exports